import React from 'react';
import { useTranslations } from 'next-intl';
import { usePathname } from '@/navigation';
import { getUserCity } from '@/shared/lib/city/getUserCity';
import { Button } from '@/shared/ui/button';
import { adaptDoctorToCard } from '../utils/adaptDoctorToCard';
import { ProfiledDoctorCard } from './ProfileDoctorCard';
import type { ProfiledDoctorsListProps } from '../model/types';
export const ProfiledDoctorsList: React.FC<ProfiledDoctorsListProps> = ({
  doctors = [],
  visibleSkill,
  onLoadMore,
  hasMore = false,
  isLoading = false
}) => {
  const t = useTranslations();
  const pathname = usePathname();
  const city = getUserCity(pathname);
  if (!doctors || doctors.length === 0) {
    return null;
  }
  return <section className="mt-4 flex flex-col gap-4" data-sentry-component="ProfiledDoctorsList" data-sentry-source-file="index.tsx">
      {doctors.map(doctor => <ProfiledDoctorCard key={doctor.id} {...adaptDoctorToCard(doctor, visibleSkill, city)} />)}
      {hasMore && onLoadMore && <Button variant="secondary-main" className="mt-4" onClick={onLoadMore} loading={isLoading} disabled={isLoading}>
          {t('medcenter.our_doctors.show_more')}
        </Button>}
    </section>;
};